export const urls = {
  feedback: "https://gaming-api.swiftysports.ie/main/v1/feedback_website",
  subscription: "https://gaming-api.swiftysports.ie/main/v1/subscription",
};
